

export function formatCartRes(res) {
    if (Object.prototype.toString.call(res) !== '[object Array]')
    {
        return res.CartDetails;
    }

    return res;
}

export function formatCartForSend(res) {
    if (Object.prototype.toString.call(res) === '[object Array]') {
        return { "CartDetails": res };
    }

    return res;
}




/** WEBPACK FOOTER **
 ** ./src/logic/formatCartRes.js
 **/